import type { ProjectDocument } from '@/lib/db/rxdb/schemas/project'

type ProjectLike = Pick<ProjectDocument, 'id' | 'projectKey' | 'parentProjectId'>

export type DocRoute =
  | {
      to: '/$workspaceSlug/spaces/$spaceKey/pages/$pageSlug'
      params: { workspaceSlug: string; spaceKey: string; pageSlug: string }
    }
  | {
      to: '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/pages/$pageSlug'
      params: { workspaceSlug: string; spaceKey: string; projectKey: string; pageSlug: string }
    }

/**
 * The URL a doc opens at: under its space for a space doc, or under
 * space › project for a project doc. Null when its location is unknown.
 */
export function docRoute(
  workspaceSlug: string,
  page: { projectId: string; slug: string },
  projects: ReadonlyArray<ProjectLike>,
): DocRoute | null {
  const location = projects.find((p) => p.id === page.projectId)
  if (!location) return null
  if (!location.parentProjectId) {
    return {
      to: '/$workspaceSlug/spaces/$spaceKey/pages/$pageSlug',
      params: { workspaceSlug, spaceKey: location.projectKey.toLowerCase(), pageSlug: page.slug },
    }
  }
  const space = projects.find((p) => p.id === location.parentProjectId)
  if (!space) return null
  return {
    to: '/$workspaceSlug/spaces/$spaceKey/projects/$projectKey/pages/$pageSlug',
    params: {
      workspaceSlug,
      spaceKey: space.projectKey.toLowerCase(),
      projectKey: location.projectKey.toLowerCase(),
      pageSlug: page.slug,
    },
  }
}
